import React from 'react';
import './CaseStudyCard.css';

const CaseStudyCard = ({ title, description, image, isCentered }) => {
  return (
    <div className={`case-card ${isCentered ? 'centered' : ''}`}>
      <div className="case-card-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <br />
      </div>
      <img src={image} alt={title} className="case-card-image" />
    </div>
  );
};

export default CaseStudyCard;